<aur-notice
  id="ach-authorization-method-notice"
  [severity]="severity$ | async"
  [formGroup]="form"
>
  <div>{{ 'ARC_PAYMENT_AUTH_CHANNEL' | translate }}</div>
  <aur-dropdown
    id="ach-authorization-method-dropdown"
    class="full-width"
    [options]="authorizationMethods"
    [formControlName]="controlName"
    [filter]="true"
  >
  </aur-dropdown>
</aur-notice>
